import { Component, Input } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../service/common.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
declare var app;
@Component({
  selector: 'app-mz-grid-list',
  templateUrl: './mz-grid-list.component.html',
  styleUrls: ['./mz-grid-list.component.scss']
})
export class MzGridListComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  testArr1 = [
    { key1: '妈妈的爱让你更懂选择', key2: '开始时间: 2017-11-25 10:30:00', key3: '地点: 江西省南昌市东湖区江西宾馆9楼' },
    { key1: '妈妈的爱让你更懂选择', key2: '开始时间: 2017-11-25 10:30:00', key3: '地点: 江西省南昌市东湖区江西宾馆9楼' },
    { key1: '妈妈的爱让你更懂选择', key2: '开始时间: 2017-11-25 10:30:00', key3: '地点: 江西省南昌市东湖区江西宾馆9楼' },
    { key1: '妈妈的爱让你更懂选择', key2: '开始时间: 2017-11-25 10:30:00', key3: '地点: 江西省南昌市东湖区江西宾馆9楼' },
    { key1: '妈妈的爱让你更懂选择', key2: '开始时间: 2017-11-25 10:30:00', key3: '地点: 江西省南昌市东湖区江西宾馆9楼' },
  ]
  testArr2 = [
    { key1: '飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”', key2: '2017-11-25' },
    { key1: '飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”', key2: '2017-11-25' },
    { key1: '飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”', key2: '2017-11-25' },
    { key1: '飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”', key2: '2017-11-25' },
    { key1: '飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”', key2: '2017-11-25' },
    { key1: '飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”', key2: '2017-11-25' }
  ]
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public com:CommonService
  ) { super(); }
  /**
    * 下拉刷新数据
    * @param event
    */
  doRefresh(event) {
    // this.LoadData();
    event.target.complete();
  }
  LoadData() {
    const that = this;
    // console.log("2019");
    // that.dataArrayList = [
    //   {title:'飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”',date:'2017-11-25',img:''},
    //   {title:'飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”',date:'2017-11-25',img:''},
    //   {title:'飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”',date:'2017-11-25',img:''},
    //   {title:'飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”',date:'2017-11-25',img:''},
    //   {title:'飞鹤乳业携手《诛仙•青云志》点燃网络观剧热潮”',date:'2017-11-25',img:''},
    //   {title:'飞鹤36个配方全部通过配方注册行业领跑荣耀入选“国家品牌计划”',date:'2017-11-25',img:''}
    // ];
  //   const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  //   let body: WebParameterContext = new WebParameterContext();
  //   if (that.element.selectItemList.gridViewConfigName) {
  //     body.ConfigName = that.element.selectItemList.gridViewConfigName;
  //   } else if (that.ConfigName) {
  //     body.ConfigName = that.ConfigName;
  //   }
  //   body.OpType = "query";
  //   body.ConfigType = "view";
  //   body.Client.Name = pageName;
  //   // if (that.platform.is("android")) {
  //   //   body.Client.ClientType = 0;
  //   // } else if (that.platform.is("ios")) {
  //   //   body.Client.ClientType = 1;
  //   // }
  //   body = HandleWebParameterContextBeforeDBRequest(body);
  //   if (!body.ResponseMessage.Success) {
  //     that.msg.Alert(body.ResponseMessage.ErrorMessage);
  //     return;
  //   }
  //   that.http.post(app.DEFAULTURL, body).then(data => {
  //     setTimeout(function () {
  //       that.apiObj['status'] = data.ResponseMessage.Success;
  //       that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
  //       that.loading = true;
  //     }, 1000);
  //     that.dataArrayList = [];
  //     data = HandleServerContextAfterDBRequest(body, data);
  //     if (data.ResponseMessage.Success) {
  //       data.Status.Datas.forEach(function (item) {
  //         let objfield = {};
  //         that.element.selectItemList.selectItem.forEach((element, index) => {
  //           if (element.bindingField) {
  //             objfield[element.bindingField] = item[element.field];
  //           }
  //         });
  //         that.dataArrayList.push(objfield);
  //         console.log(that.element.selectItemList.selectItem);
  //         console.log(that.dataArrayList);
  //       });
  //     } else {
  //       that.msg.Alert(data.ResponseMessage.ErrorMessage);
  //       console.log(data.ResponseMessage.ErrorMessage);
  //     }
  // }).catch(error => {
  //     that.apiObj['status'] = false;
  //     that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
  //     that.loading = true;
  //     console.log(error);
  // })
}
EventLink(ev: any, parms: any) {
  let evs = ev.url || '';
  if (evs.trim() && parms) {
    if (evs.indexOf("http") > 0) {
    } else {
      this.com.setHistoryUrl();
      this.com.Go(evs + "/" + parms.a_ID);
    }
  }
}
}
